module.exports = "<div class=\"input-group\">\r\n  <input \r\n    type=\"text\" \r\n    (change)=\"emit()\" \r\n    [id]=\"element\" \r\n    [ngClass]=\"{'is-invalid':error}\" \r\n    class=\"form-control date\" \r\n    [readonly]=\"readonly\">\r\n  \r\n  <div class=\"input-group-append\">\r\n    <span class=\"input-group-text\">\r\n      <i class=\"fa fa-calendar\"></i>\r\n    </span>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/datepicker/datepicker.component.html
// module id = ./src/app/components/tools/datepicker/datepicker.component.html
// module chunks = main